<template>
	<app-content class="h-panel">
		<Loading text="数据加载中..." :loading="loading"></Loading>
		<div class="h-panel-bar">
			<span class="h-panel-title"><template v-if="report">{{report.name}}</template>&nbsp;</span>
			<Button class="float-right" @click="$router.back()">返回</Button>
		</div>
		<div class="margin-top margin-left margin-right">
			<template v-if="report.type==0">
				<Radio type="text" v-model="reportPeriodType" :datas="reportPeriodTypes"></Radio>
				<account-date-choose v-if="reportPeriodType==='month'" v-model="accountDate"/>
				<Select v-else v-model="quarterDate" keyName="value" titleName="title" style="display: inline-block; min-width: 130px" :deletable="false" :datas="quarterOptions"/>
			</template>
			<account-date-choose v-else v-model="accountDate"/>
			<router-link :to="{name:'TemplateForm',params:{templateId:reportId}}"><button class="h-btn float-right" v-if="User.role!=='View'">编辑数据项</button></router-link>
		</div>
		<div class="h-panel-body">
			<Table class="small-td" :datas="templateItems" selectRow border v-if="report.type==0">
				<TableItem title="名称">
					<div slot-scope="{data}" :class="{'font-bold':data.isBolder}" :style="{paddingLeft:((data.level-1)*15)+'px'}">{{data.title}}</div>
				</TableItem>
				<TableItem title="行次">
					<template slot-scope="{data}">
						{{data.isClassified ? '':data.lineNum>-1?data.lineNum:''}}
					</template>
				</TableItem>
				<TableItem title="本年累计金额" align="right">
					<template slot-scope="{data}">
						{{reportData[data.id]?reportData[data.id].currentYearAmount:''|numFormat}}
					</template>
				</TableItem>
				<TableItem title="本期金额" align="right">
					<template slot-scope="{data}">
						{{reportData[data.id]?reportData[data.id].currentPeriodAmount:''|numFormat}}
					</template>
				</TableItem>
			</Table>
			<Table class="small-td" :datas="templateItems" selectRow border v-else-if="report.type==2">
				<TableItem title="项目">
					<div slot-scope="{data}" :class="{'font-bold':data.isBolder}" :style="{paddingLeft:((data.level-1)*15)+'px'}">{{data.title}}</div>
				</TableItem>
				<TableItem title="行次">
					<template slot-scope="{data}">
						{{data.isClassified ? '':data.lineNum>-1?data.lineNum:''}}
					</template>
				</TableItem>
				<TableItem title="本年累计金额" align="right">
					<template slot-scope="{data}">
						{{formatCashFlowAmount(reportData[data.id] && reportData[data.id].currentYearAmount)}}
					</template>
				</TableItem>
				<TableItem title="本期金额" align="right">
					<template slot-scope="{data}">
						{{formatCashFlowAmount(reportData[data.id] && reportData[data.id].currentPeriodAmount)}}
					</template>
				</TableItem>
			</Table>
			<Table :datas="templateItemsRender" selectRow border v-else-if="report.type == 1">
				<TableItem title="资产">
					<div slot-scope="{data}" :class="{'font-bold':data.isBolder}" :style="{paddingLeft:((data.level-1)*15)+'px'}">{{data.title}}</div>
				</TableItem>
				<TableItem title="行次">
					<template slot-scope="{data}">
						{{data.isClassified ? '':data.lineNum>-1?data.lineNum:''}}
					</template>
				</TableItem>
				<TableItem title="期末余额" align="right">
					<template slot-scope="{data}">
						{{reportData[data.id]?reportData[data.id].currentPeriodAmount:''|numFormat}}
					</template>
				</TableItem>
				<TableItem title="年初余额" align="right">
					<template slot-scope="{data}">
						{{reportData[data.id]?reportData[data.id].currentYearAmount:''|numFormat}}
					</template>
				</TableItem>
				<TableItem title="负债和所有者权益">
					<div slot-scope="{data}" :class="{'font-bold':data.fs_isBolder}" :style="{paddingLeft:((data.fs_level-1)*15)+'px'}">{{data.fs_title}}</div>
				</TableItem>
				<TableItem title="行次">
					<template slot-scope="{data}">
						{{data.fs_isClassified ? '':data.fs_lineNum>-1?data.fs_lineNum:''}}
					</template>
				</TableItem>
				<TableItem title="期末余额" align="right">
					<template slot-scope="{data}">
						{{reportData[data.fs_id]?reportData[data.fs_id].currentPeriodAmount:''|numFormat}}
					</template>
				</TableItem>
				<TableItem title="年初余额" align="right">
					<template slot-scope="{data}">
						{{reportData[data.fs_id]?reportData[data.fs_id].currentYearAmount:''|numFormat}}
					</template>
				</TableItem>
			</Table>
		</div>
	</app-content>
</template>

<script>
	import {mapState} from 'vuex'
	import moment from 'moment'

	export default {
		name: "ReportView.vue",
		props: {
			reportId: [Number, String]
		},
		data() {
			return {
				report: {},
				reportData: {},
				accountDate: null,
				quarterDate: null,
				reportPeriodType: 'month',
				reportPeriodTypes: [
					{key: 'month', title: '月报'},
					{key: 'quarter', title: '季报'}
				],
				loading: false
			}
		},
		computed: {
			...mapState(['User']),
			templateItems() {
				return this.report ? this.report.items : [];
			},
			quarterOptions() {
				let options = {};
				(this.User.checkoutList || []).forEach(item => {
					let quarter = Math.ceil(item.checkMonth / 3);
					let value = moment({years: item.checkYear, months: quarter * 3 - 1, days: 1}).endOf('month').format('YYYY-MM-DD');
					options[item.checkYear + '-' + quarter] = {
						value,
						title: item.checkYear + '年第' + quarter + '季度',
						year: item.checkYear,
						quarter
					};
				});
				return Object.keys(options).map(key => options[key]).sort((a, b) => {
					return a.year === b.year ? a.quarter - b.quarter : b.year - a.year;
				});
			},
			templateItemsRender() {
				if (this.report.type === 1) {
					//所有资产
					let zc = this.templateItems.filter(val => val.type === 0);
					let sq = this.templateItems.filter(val => val.type !== 0);
					sq.forEach((val, index) => {
						let changeObj = {
							fs_id: val.id,
							fs_lineNum: val.lineNum,
							fs_isBolder: val.isBolder,
							fs_level: val.level,
							fs_isClassified: val.isClassified,
							fs_title: val.title
						};
						if (zc[index]) {
							Object.assign(zc[index], changeObj);
						}
					});
					return zc;
				}
				return [];
			}
		},
		watch: {
			accountDate(val) {
				if (this.reportPeriodType === 'quarter') {
					let quarterEndDate = this.getQuarterEndDate(val);
					if (quarterEndDate && this.quarterDate !== quarterEndDate) {
						this.quarterDate = quarterEndDate;
					}
				}
				this.loadReport();
			},
			quarterDate(val) {
				if (this.reportPeriodType === 'quarter' && val && val !== this.accountDate) {
					this.accountDate = val;
				}
			},
			reportPeriodType(val) {
				if (val === 'quarter') {
					let quarterEndDate = this.getQuarterEndDate(this.accountDate) || (this.quarterOptions[0] && this.quarterOptions[0].value);
					this.quarterDate = quarterEndDate;
					if (quarterEndDate && quarterEndDate !== this.accountDate) {
						this.accountDate = quarterEndDate;
						return;
					}
				}
				this.loadReportData();
			},
			reportId() {
				this.loadReport();
			}
		},
		methods: {
			loadReport() {
				Api.report.template.load(this.reportId).then(({data}) => {
					this.report = data;
					this.$nextTick(this.loadReportData);
				});
			},
			loadReportData() {
				if (!this.accountDate) {
					return;
				}
				let params = {accountDate: this.accountDate};
				if (this.report.type === 0) {
					params.periodType = this.reportPeriodType;
				}
				this.loading = true;
				Api.report.view(this.reportId, params).then(({data}) => {
					this.reportData = data;
				}).finally(() => this.loading = false);
			},
			formatCashFlowAmount(value) {
				if (value === null || value === undefined || value === '') {
					return '';
				}
				let amount = Number(value);
				if (isNaN(amount)) {
					return '';
				}
				return amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
			},
			getQuarterEndDate(date) {
				if (!date) {
					return null;
				}
				let month = moment(date).month();
				return moment(date).month(Math.floor(month / 3) * 3 + 2).endOf('month').format('YYYY-MM-DD');
			}
		}
	}
</script>

<style scoped>
	div.font-bold {
		font-size: 14px;
	}
</style>